module.exports = __webpack_public_path__ + "img/picto-tab-spiritualite.0aeafd02.svg";